import http from "../http-common";
/* eslint-disable */
class EvaluasiFasilitatorService {
  evaluasiFasilitatorList(page, itemPerPage, keyword) {
    return http.get(
      "/pelatihan-evaluasi-fasilitator/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    return http.post("/pelatihan-evaluasi-fasilitator", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  update(data) {
    return http.put(`/pelatihan-evaluasi-fasilitator/${data.id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  delete(id) {
    return http.delete(`/pelatihan-evaluasi-fasilitator/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}

export default new EvaluasiFasilitatorService();
